import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getJSONData (file) {
        return httpService.get(ApiEndpoints.get('json_consent', { file }));
    }
};
